import type { ValorantRegion } from 'generated/openapi';

export const REGION_DISPLAY_NAMES: Record<ValorantRegion, string> = {
  NA: 'North America',
  EU: 'Europe',
  AP: 'Asia Pacific',
  KR: 'Korea',
  BR: 'Brazil',
  LATAM: 'Latin America',
  UNKNOWN: 'Unknown',
};

export function getRegionDisplayName(region: ValorantRegion): string {
  return REGION_DISPLAY_NAMES[region];
}
